<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="attributeValueHeaders"
        :items="admin.attributeValueList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.attributeValueList.length == 0"
        :hide-default-header="admin.attributeValueList.length == 0"
      >
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewAttributeValue"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        attributeValueHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'LABEL', value: 'label' },
          { text: 'VALUE', value: 'value' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedAttributeValueSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedAttributeValueSelectionModel',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Product Attribute to currently selected product
       */
      addNewAttributeValue() {
        this.$store.commit('admin/setSelectedAttributeValue', {
          id: 'new',
          attributeId: this.admin.selectedAttribute.id,
          label: '',
          value: '',
          published: false
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedAttributeValue', data.item);
        } else {
          this.$store.commit('admin/setSelectedAttributeValue', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedAttributeValueSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // clear children
      }
    }
  };
</script>
